import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import './TicketDetail.css';
import { Host } from '../../App';

const TicketDetail = ({ ticketId: propTicketId, onBack }) => {
  const { id } = useParams();
  const ticketId = propTicketId || id;
  const history = useHistory();
  const token = window.localStorage.getItem('acessToken');
  const userName = JSON.parse(window.localStorage.getItem('Name'));

  const [ticket, setTicket] = useState(null);
  const [activityLog, setActivityLog] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isManager, setIsManager] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showAssigneeModal, setShowAssigneeModal] = useState(false);
  const [assigneeName, setAssigneeName] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState('');

  // Edit Ticket Modal States
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [editReason, setEditReason] = useState('');
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [pendingChanges, setPendingChanges] = useState(null);

  // Recurring Ticket States
  const [instances, setInstances] = useState([]);
  const [showInstances, setShowInstances] = useState(true);
  const [isLoadingInstances, setIsLoadingInstances] = useState(false);
  const [showCloseSeriesModal, setShowCloseSeriesModal] = useState(false);
  const [closeSeriesReason, setCloseSeriesReason] = useState('');
  const [showCreateInstanceModal, setShowCreateInstanceModal] = useState(false);
  const [instanceDate, setInstanceDate] = useState(new Date().toISOString().slice(0, 10));
  const [isCreatingInstance, setIsCreatingInstance] = useState(false);

  // Overdue Date Warning Popup
  const [showOverdueWarning, setShowOverdueWarning] = useState(false);
  const [overdueMessage, setOverdueMessage] = useState('');

  // Purchase Request States
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [purchaseRequests, setPurchaseRequests] = useState([]);
  const [showPurchaseList, setShowPurchaseList] = useState(true);
  const [isLoadingPurchases, setIsLoadingPurchases] = useState(false);
  const [selectedPurchaseRequest, setSelectedPurchaseRequest] = useState(null);
  const [showPurchaseDetail, setShowPurchaseDetail] = useState(false);

  // Purchase Data for dropdowns
  const [purchaseData, setPurchaseData] = useState([]);
  const [isLoadingPurchaseData, setIsLoadingPurchaseData] = useState(false);

  // Purchase Form States
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [files, setFiles] = useState([]);
  const [isSubmittingPurchase, setIsSubmittingPurchase] = useState(false);
  const [purchaseFormData, setPurchaseFormData] = useState({
    Request_date: new Date().toISOString().slice(0, 10),
    name: userName,
    Part_No: "",
    item_description: "",
    brand: "",
    qty: "",
    unit: "",
    vendor: "",
    required_before: new Date().toISOString().slice(0, 10),
    comments: "",
    Ticket_No: ticketId || ""
  });

  // Completion Modal States
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [completionData, setCompletionData] = useState({
    completion_notes: '',
    delay_reason: '',
    is_delayed: false,
    warning_message: ''
  });
  const [isSubmittingComplete, setIsSubmittingComplete] = useState(false);

  // Comments state
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([]);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const [highlightedCommentId, setHighlightedCommentId] = useState(null);
  const commentInputRef = useRef(null);

  // Reopen Ticket State
  const [showReopenModal, setShowReopenModal] = useState(false);
  const [reopenReason, setReopenReason] = useState('');
  const [isReopening, setIsReopening] = useState(false);

  // Rejection Modal States
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [isRejecting, setIsRejecting] = useState(false);

  // Delete Ticket States (manager-only, permanently removes the DB record)
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [isDeletingRecord, setIsDeletingRecord] = useState(false);

  // Hardcoded employees list for assignee
  const employeeList = ["Rigan Inpam"];

  useEffect(() => {
    checkUserRole();
    fetchTicketDetails();
    fetchPurchaseData();
  }, [ticketId]);

  // Check for overdue warning when ticket loads
  useEffect(() => {
    if (ticket) {
      checkForOverdueWarning();
      fetchPurchaseRequests();
      if (ticket.is_recurring) {
        fetchInstances();
      }
      // Check for pending modifications
      if (ticket.approval_type === 'modification' && ticket.pending_data) {
        try {
          const pendingData = typeof ticket.pending_data === 'string'
            ? JSON.parse(ticket.pending_data)
            : ticket.pending_data;
          setPendingChanges(pendingData);
        } catch (e) {
          setPendingChanges(null);
        }
      } else {
        setPendingChanges(null);
      }
    }
  }, [ticket]);

  // ===== FORMAT DATE WITHOUT TIMEZONE CONVERSION =====
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const datePart = dateString.split('T')[0];
      if (!datePart) return dateString;

      const [year, month, day] = datePart.split('-');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthName = months[parseInt(month) - 1];
      return `${monthName} ${parseInt(day)}, ${year}`;
    } catch (e) {
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      let datePart, timePart;
      if (dateString.includes('T')) {
        [datePart, timePart] = dateString.split('T');
      } else if (dateString.includes(' ')) {
        [datePart, timePart] = dateString.split(' ');
      } else {
        return dateString;
      }

      const [year, month, day] = datePart.split('-');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthName = months[parseInt(month) - 1];
      const formattedDate = `${monthName} ${parseInt(day)}, ${year}`;

      if (timePart) {
        const time = timePart.split('.')[0];
        const [hours, minutes] = time.split(':');
        let hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        const formattedTime = `${hour}:${minutes} ${ampm}`;
        return `${formattedDate} at ${formattedTime}`;
      }

      return formattedDate;
    } catch (e) {
      return dateString;
    }
  };

  // ===== CHECK FOR OVERDUE WARNING =====
  const checkForOverdueWarning = () => {
    if (!ticket) return;

    if (ticket.recurrence_parent_id && ticket.status === 'closed') {
      return;
    }

    if (ticket.status === 'completed' || ticket.status === 'closed' || ticket.status === 'cancelled') {
      return;
    }

    const dateInfo = getDateInfo(ticket);
    const dateValue = ticket[dateInfo.field];

    if (!dateValue) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDate = new Date(dateValue.split('T')[0]);
    dueDate.setHours(0, 0, 0, 0);

    if (dueDate < today) {
      const daysOverdue = Math.floor((today - dueDate) / (1000 * 60 * 60 * 24));

      let message = `⚠️ This ticket is ${daysOverdue} day${daysOverdue > 1 ? 's' : ''} overdue! The ${dateInfo.label} was ${formatDate(dateValue)}.`;

      if (ticket.is_recurring && ticket.recurrence_instance_date) {
        message += ` This is for the instance of ${formatDate(ticket.recurrence_instance_date)}.`;
      }

      message += ` Please update the date or complete the work.`;

      setOverdueMessage(message);
      setShowOverdueWarning(true);
    }
  };

  // ===== CHECK PURCHASE REQUEST COMPLETION DATE =====
  const checkPurchaseRequestCompletion = (purchaseRequest) => {
    if (!purchaseRequest || !ticket) return;

    const completionTime = purchaseRequest.Completion_Time || purchaseRequest.completion_time;
    const tentativeDate = ticket.tentative_completion_date || ticket.assigned_completion_date;

    if (!completionTime || !tentativeDate) return;

    const completionDate = new Date(completionTime.split('T')[0]);
    completionDate.setHours(0, 0, 0, 0);
    const tentative = new Date(tentativeDate.split('T')[0]);
    tentative.setHours(0, 0, 0, 0);

    if (completionDate > tentative) {
      const daysLate = Math.floor((completionDate - tentative) / (1000 * 60 * 60 * 24));
      setOverdueMessage(
        `⚠️ Purchase Request (${purchaseRequest.Part_No || 'N/A'}) has a Completion Date of ${formatDate(completionTime)}. ` +
        `This is ${daysLate} day${daysLate > 1 ? 's' : ''} after the Tentative Completion Date (${formatDate(tentativeDate)}). ` +
        `The part may arrive late!`
      );
      setShowOverdueWarning(true);
    }
  };

  // ===== FETCH PURCHASE DATA FOR DROPDOWNS =====
  const fetchPurchaseData = async () => {
    setIsLoadingPurchaseData(true);
    try {
      const response = await axios.get(`https://` + Host + `/Purchase_Requisitions/alldata`, {
        params: { token }
      });
      if (Array.isArray(response.data)) {
        setPurchaseData(response.data);
      } else {
        setPurchaseData([]);
      }
    } catch (error) {
      console.error('Error fetching purchase data:', error);
      setPurchaseData([]);
    } finally {
      setIsLoadingPurchaseData(false);
    }
  };

  // Helper function to get unique values from purchase data
  const getUniqueValues = (key) => {
    if (!Array.isArray(purchaseData) || purchaseData.length === 0) {
      return [];
    }
    return [...new Set(purchaseData.map(item => item[key]).filter(Boolean))];
  };

  // ===== AUTO-FILL FUNCTION WHEN PART NO IS SELECTED =====
  const handlePartNoChange = (e) => {
    const selectedPartNo = e.target.value;

    setPurchaseFormData(prev => ({
      ...prev,
      Part_No: selectedPartNo
    }));

    if (selectedPartNo) {
      const matchedRecord = purchaseData.find(
        item => item.Part_No === selectedPartNo
      );

      if (matchedRecord) {
        setPurchaseFormData(prev => ({
          ...prev,
          Part_No: selectedPartNo,
          item_description: matchedRecord.Item_Desc || prev.item_description,
          brand: matchedRecord.Brand || prev.brand,
          vendor: matchedRecord.Vendor || prev.vendor,
          unit: matchedRecord.Unit || prev.unit
        }));
      }
    }
  };

  // ===== CHECK USER ROLE =====
  const checkUserRole = async () => {
    try {
      const response = await axios.get(`https://` + Host + `/api/user-info`, {
        params: { token }
      });
      if (response.data) {
        setIsManager(response.data.Stage === '2' || response.data.Ranked === 'Admin' || response.data.Section === 'Manager');
        setIsMaintenance(response.data.Section === 'Maintenance' || response.data.Section === 'Manager');
      }
    } catch (error) {
      console.error('Error checking user role:', error);
    }
  };

  // ===== FORMAT DATE FOR INPUT FIELD =====
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    try {
      // If it's already in YYYY-MM-DD format
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return dateString;
      }

      // If it's a full ISO string
      if (dateString.includes('T')) {
        const datePart = dateString.split('T')[0];
        if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return datePart;
        }
      }

      // Try to create a date object and format it
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      return '';
    } catch (e) {
      console.error('Error formatting date:', e);
      return '';
    }
  };

  // ===== FETCH TICKET DETAILS =====
  const fetchTicketDetails = async () => {
    if (!ticketId) return;
    setIsLoading(true);
    try {
      const response = await axios.get(`https://` + Host + `/maintenance/api/tickets/${ticketId}`, {
        params: { token }
      });
      console.log('Ticket details response:', response.data);
      if (response.data) {
        const ticketData = response.data.ticket || response.data;
        setTicket(ticketData);
        setActivityLog(response.data.activity_log || []);
        await fetchComments();
        setAssigneeName(ticketData.assigned_to || '');

        // Check for pending modifications
        if (ticketData.approval_type === 'modification' && ticketData.pending_data) {
          try {
            const pendingData = typeof ticketData.pending_data === 'string'
              ? JSON.parse(ticketData.pending_data)
              : ticketData.pending_data;
            setPendingChanges(pendingData);
          } catch (e) {
            setPendingChanges(null);
          }
        } else {
          setPendingChanges(null);
        }
      }
    } catch (error) {
      console.error('Error fetching ticket details:', error);
      if (error.response && error.response.status === 404) {
        alert('Ticket not found');
        history.push('/maintenance');
      } else {
        alert('Failed to load ticket details');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ===== FETCH COMMENTS =====
  const fetchComments = async () => {
    try {
      const response = await axios.get(`https://` + Host + `/maintenance/api/tickets/${ticketId}/comments`, {
        params: { token }
      });
      if (response.data && response.data.success) {
        setComments(response.data.comments || []);
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
      setComments([]);
    }
  };

  // ===== FETCH RECURRING INSTANCES =====
  const fetchInstances = async () => {
    if (!ticketId || !ticket?.is_recurring) return;
    setIsLoadingInstances(true);
    try {
      const response = await axios.get(
        `https://` + Host + `/maintenance/api/tickets/${ticketId}/instances`,
        { params: { token } }
      );
      if (response.data && response.data.success) {
        setInstances(response.data.instances || []);
      }
    } catch (error) {
      console.error('Error fetching instances:', error);
      setInstances([]);
    } finally {
      setIsLoadingInstances(false);
    }
  };

  // ===== FETCH PURCHASE REQUESTS =====
  const fetchPurchaseRequests = async () => {
    if (!ticketId) return;
    setIsLoadingPurchases(true);
    try {
      const response = await axios.get(
        `https://` + Host + `/Purchase_Requisitions/by-ticket/${ticketId}`,
        { params: { token } }
      );
      setPurchaseRequests(response.data || []);

      if (response.data && response.data.length > 0 && ticket) {
        response.data.forEach(req => {
          checkPurchaseRequestCompletion(req);
        });
      }
    } catch (error) {
      console.error('Error fetching purchase requests:', error);
      setPurchaseRequests([]);
    } finally {
      setIsLoadingPurchases(false);
    }
  };

  // ===== HANDLE PURCHASE FORM =====
  const handlePurchaseChange = (e) => {
    const { name, value } = e.target;
    setPurchaseFormData({ ...purchaseFormData, [name]: value });
  };

  const handlePurchaseFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handlePurchaseSubmit = async () => {
    if (ticket.approval_status !== 'Approved' && ticket.approval_status !== 'approved') {
      alert('⚠️ Purchase requests can only be created for approved tickets. Please wait for manager approval.');
      return;
    }

    if (!purchaseFormData.Part_No.trim()) {
      alert('Please enter a Part Number');
      return;
    }
    if (!purchaseFormData.item_description.trim()) {
      alert('Please enter an Item Description');
      return;
    }
    if (!purchaseFormData.qty || purchaseFormData.qty <= 0) {
      alert('Please enter a valid quantity');
      return;
    }

    setIsSubmittingPurchase(true);
    const data = new FormData();
    data.append("token", token);
    Object.entries(purchaseFormData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        data.append(key, value);
      }
    });

    try {
      let response;
      if (files.length === 0) {

        response = await axios.post(`https://` + Host + `/add/withoutfile/maintenance/Purchase_Requisitions`, data, token);
      } else {
        files.forEach((file) => {

          const fileExtension = file.name.split('.').pop();
          const uniqueFileName = `${Date.now()}.${fileExtension}`;
          data.append("files", file, uniqueFileName);
        });

        response = await axios.post(`https://` + Host + `/add/maintenance/Purchase_Requisitions`, data, token, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      if (response.status === 200) {
        alert(response.data.message || 'Purchase request submitted successfully!');
        setShowPurchaseModal(false);
        setShowPurchaseList(true);
        fetchPurchaseRequests();
        setSuccessMessage('Purchase request created successfully!');
        setShowSuccessModal(true);
        setPurchaseFormData({
          ...purchaseFormData,
          Part_No: "",
          item_description: "",
          brand: "",
          qty: "",
          unit: "",
          vendor: "",
          comments: ""
        });
        setFiles([]);
      }
    } catch (error) {
      console.error("Upload error:", error.response || error);
      alert(error.response?.data?.message || 'Failed to submit purchase request');
    } finally {
      setIsSubmittingPurchase(false);
    }
  };

  // ===== VIEW PURCHASE DETAIL =====
  const viewPurchaseDetail = async (ticketNo) => {
    try {
      if (!ticketNo) {
        alert('Invalid ticket number');
        return;
      }

      const response = await axios.get(
        `https://` + Host + `/Purchase_Requisitions/by-ticket-no/${ticketNo}`,
        { params: { token } }
      );

      if (response.data && Object.keys(response.data).length > 0) {
        setSelectedPurchaseRequest(response.data);
        setShowPurchaseDetail(true);
        if (ticket) {
          checkPurchaseRequestCompletion(response.data);
        }
      } else {
        alert('No purchase request found for this ticket');
      }
    } catch (error) {
      console.error('Error fetching purchase detail:', error);
      alert('Failed to load purchase request details: ' + (error.response?.data?.message || error.message));
    }
  };

  // ===== GET DATE INFO BASED ON TICKET TYPE =====
  const getDateInfo = (ticket) => {
    if (!ticket) return { field: 'assigned_completion_date', label: 'Assigned Completion Date' };

    if (ticket.type === 'prescheduled' || ticket.is_recurring) {
      return {
        field: 'schedule_start_date',
        label: 'Effective Date',
        hint: 'This is the date when the recurring schedule starts'
      };
    }
    return {
      field: 'tentative_completion_date',
      label: 'Tentative Completion Date',
      hint: 'This is the estimated date when work will be completed'
    };
  };

  // ===== CHECK IF DATE IS OVERDUE =====
  const isDateOverdue = (ticket) => {
    if (!ticket) return false;

    if (ticket.recurrence_parent_id && ticket.status === 'closed') {
      return false;
    }

    const dateInfo = getDateInfo(ticket);
    const dateValue = ticket[dateInfo.field];
    if (!dateValue) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDate = new Date(dateValue.split('T')[0]);
    dueDate.setHours(0, 0, 0, 0);

    return dueDate < today && ticket.status !== 'completed' && ticket.status !== 'closed' && ticket.status !== 'cancelled';
  };

  // ===== HANDLE COMPLETION =====
  const openCompleteModal = () => {
    const isOverdue = isDateOverdue(ticket);

    let warningMessage = '';
    if (ticket.is_recurring && ticket.recurrence_parent_id) {
      warningMessage = '⚠️ This will only close the current instance. A new instance will be created automatically for the next period.';
    } else if (ticket.is_recurring && !ticket.recurrence_parent_id) {
      alert('⚠️ This is the parent recurring ticket. Please complete individual instances instead.');
      return;
    }

    setCompletionData({
      completion_notes: '',
      delay_reason: '',
      is_delayed: isOverdue,
      warning_message: warningMessage
    });
    setShowCompleteModal(true);
  };

  const handleCompleteSubmit = async () => {
    if (!completionData.completion_notes.trim()) {
      alert('Please provide completion notes');
      return;
    }

    if (completionData.is_delayed && !completionData.delay_reason.trim()) {
      alert('Please provide a reason for the delay');
      return;
    }

    setIsSubmittingComplete(true);
    try {
      const payload = {
        token,
        ticketId: ticket.id,
        completed_by: userName,
        completed_at: new Date().toISOString(),
        completion_notes: completionData.completion_notes.trim(),
        delay_reason: completionData.is_delayed ? completionData.delay_reason.trim() : null,
        status: 'completed',
        approval_status: 'Pending',
        approval_type: 'completion',
        pending_data: JSON.stringify({
          completion_notes: completionData.completion_notes.trim(),
          completed_by: userName,
          completed_at: new Date().toISOString(),
          delay_reason: completionData.is_delayed ? completionData.delay_reason.trim() : null,
          is_delayed: completionData.is_delayed,
          is_recurring: ticket.is_recurring,
          recurrence_parent_id: ticket.recurrence_parent_id
        })
      };

      const response = await axios.post(`https://` + Host + `/maintenance/api/tickets/complete`, payload);

      let successMsg = 'Ticket marked as completed! Waiting for manager approval.';
      if (response.data && response.data.new_instance_id) {
        successMsg = '✅ Current instance completed successfully! A new instance has been created for the next period.';
      }

      setSuccessMessage(successMsg);
      setShowSuccessModal(true);
      setShowCompleteModal(false);
      fetchTicketDetails();
      if (ticket.is_recurring) {
        fetchInstances();
      }
    } catch (error) {
      console.error('Error completing ticket:', error);
      alert(error.response?.data?.error || 'Failed to complete ticket');
    } finally {
      setIsSubmittingComplete(false);
    }
  };

  // ===== HANDLE APPROVE COMPLETION =====
  const approveCompletion = async () => {
    if (!ticket) return;

    try {
      const response = await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          status: 'closed',
          approval_status: 'Approved',
          approval_type: null,
          pending_data: null,
          closed_by: userName,
          closed_at: new Date().toISOString()
        },
        { params: { token } }
      );

      let successMsg = 'Completion approved! Ticket closed.';
      if (ticket.is_recurring && response.data && response.data.new_instance_id) {
        successMsg = '✅ Completion approved! Instance closed. A new instance has been created for the next period.';
      }

      setSuccessMessage(successMsg);
      setShowSuccessModal(true);
      fetchTicketDetails();
      if (ticket.is_recurring) {
        fetchInstances();
      }
    } catch (error) {
      console.error('Error approving completion:', error);
      alert('Failed to approve completion');
    }
  };

  // ===== HANDLE REJECT COMPLETION =====
  const rejectCompletion = () => {
    // Show modal instead of prompt
    setRejectReason('');
    setShowRejectModal(true);
  };

  const handleRejectConfirm = async () => {
    if (!rejectReason.trim()) {
      alert('Please provide a reason for rejecting this completion');
      return;
    }

    setIsRejecting(true);
    try {
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          approval_status: 'Rejected',
          approval_type: 'completion',
          manager_comments: `Completion rejected: ${rejectReason.trim()}`
        },
        { params: { token } }
      );

      setSuccessMessage('Completion has been rejected. The maintenance team can reopen the ticket to fix and resubmit.');
      setShowSuccessModal(true);
      setShowRejectModal(false);
      fetchTicketDetails();
    } catch (error) {
      console.error('Error rejecting completion:', error);
      alert('Failed to reject completion');
    } finally {
      setIsRejecting(false);
    }
  };

  // ===== HANDLE REOPEN TICKET =====
  const openReopenModal = () => {
    setReopenReason('');
    setShowReopenModal(true);
  };

  // ===== HANDLE REOPEN TICKET =====
  const handleReopenTicket = async () => {
    // Validate that a reason is provided
    if (!reopenReason.trim()) {
      alert('Please provide a reason for reopening');
      return;
    }

    setIsReopening(true);
    try {
      // Update the ticket status and clear approval data
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          status: 'in_progress',           // Set back to in progress
          approval_status: 'Pending',       // Reset approval to pending
          approval_type: null,              // Clear approval type
          pending_data: null,               // Clear pending data
          manager_comments: `Ticket reopened: ${reopenReason.trim()}` // Add reason to comments
        },
        { params: { token } }
      );

      setSuccessMessage('Ticket reopened and set to In Progress. Please complete the work properly and resubmit.');
      setShowSuccessModal(true);
      setShowReopenModal(false);
      fetchTicketDetails(); // Refresh the ticket details
    } catch (error) {
      console.error('Error reopening ticket:', error);
      alert('Failed to reopen ticket: ' + (error.response?.data?.error || error.message));
    } finally {
      setIsReopening(false);
    }
  };

  // ===== HANDLE EDIT TICKET =====
  const openEditModal = () => {
    // Initialize form with current ticket values - properly formatted for inputs
    setEditFormData({
      issue_description: ticket.issue_description || '',
      maintenance_category: ticket.maintenance_category || '',
      type: ticket.type || 'emergent',
      priority: ticket.priority || 'Medium',
      assigned_completion_date: formatDateForInput(ticket.assigned_completion_date),
      tentative_completion_date: formatDateForInput(ticket.tentative_completion_date),
      schedule_start_date: formatDateForInput(ticket.schedule_start_date),
      schedule_end_date: formatDateForInput(ticket.schedule_end_date)
    });
    setEditReason('');
    setShowEditModal(true);
  };

  const handleEditSubmit = async () => {
    // Build changes object with only fields that changed
    const changes = {};
    const fields = [
      'issue_description',
      'maintenance_category',
      'type',
      'priority',
      'assigned_completion_date',
      'tentative_completion_date',
      'schedule_start_date',
      'schedule_end_date'
    ];

    let hasChanges = false;
    fields.forEach(field => {
      if (editFormData[field] !== ticket[field]) {
        changes[field] = editFormData[field];
        hasChanges = true;
      }
    });

    if (!hasChanges) {
      alert('No changes detected. Please modify at least one field.');
      return;
    }

    changes.reason = editReason || 'No reason provided';

    setIsSubmittingEdit(true);
    try {
      if (!isManager) {
        const payload = {
          token,
          ticketId: ticket.id,
          requested_by: userName,
          changes: changes
        };

        await axios.post(`https://` + Host + `/maintenance/api/tickets/modification`, payload);
        setSuccessMessage('Modification request submitted for manager approval!');
        setShowSuccessModal(true);
      } else {
        const updateData = { ...changes };
        delete updateData.reason;
        updateData.manager_comments = `Changes applied by manager: ${editReason || 'No reason provided'}`;

        await axios.patch(
          `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
          updateData,
          { params: { token } }
        );
        setSuccessMessage('Ticket updated successfully!');
        setShowSuccessModal(true);
      }

      setShowEditModal(false);
      fetchTicketDetails();
    } catch (error) {
      console.error('Error updating ticket:', error);
      alert(error.response?.data?.error || 'Failed to update ticket');
    } finally {
      setIsSubmittingEdit(false);
    }
  };

  // Check if a field has pending changes
  const hasPendingChange = (fieldName) => {
    if (!pendingChanges) return false;
    return pendingChanges[fieldName] !== undefined;
  };

  // Get pending change value for a field
  const getPendingChangeValue = (fieldName) => {
    if (!pendingChanges) return null;
    return pendingChanges[fieldName];
  };

  // ===== HANDLE COMMENT SUBMIT =====
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) {
      alert('Please enter a comment');
      return;
    }

    setIsSubmittingComment(true);
    try {
      await axios.post(
        `https://` + Host + `/maintenance/api/tickets/${ticketId}/comment`,
        {
          token,
          comment: comment.trim(),
          userName: userName
        }
      );

      setComment('');
      setHighlightedCommentId(Date.now());
      fetchTicketDetails();

      setTimeout(() => {
        setHighlightedCommentId(null);
      }, 3000);
    } catch (error) {
      console.error('Error submitting comment:', error);
      alert('Failed to submit comment');
    } finally {
      setIsSubmittingComment(false);
    }
  };

  // ===== HANDLE STATUS UPDATE =====
  const updateStatus = async (newStatus) => {
    if (!ticket) return;

    try {
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        { status: newStatus },
        { params: { token } }
      );

      setSuccessMessage(`Status updated to ${newStatus.replace('_', ' ')}`);
      setShowSuccessModal(true);
      fetchTicketDetails();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status');
    }
  };

  // ===== HANDLE ASSIGNEE UPDATE =====
  const handleAssigneeUpdate = async () => {
    if (!assigneeName.trim()) {
      alert('Please select an assignee');
      return;
    }

    try {
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          assigned_to: assigneeName.trim(),
          assigned_date: new Date().toISOString().slice(0, 10)
        },
        { params: { token } }
      );

      setSuccessMessage(`Ticket assigned to ${assigneeName}`);
      setShowSuccessModal(true);
      setShowAssigneeModal(false);
      fetchTicketDetails();
    } catch (error) {
      console.error('Error assigning ticket:', error);
      alert('Failed to assign ticket');
    }
  };

  // ===== HANDLE CANCEL TICKET =====
  const handleCancelTicket = async () => {
    if (!cancellationReason.trim()) {
      alert('Please provide a cancellation reason');
      return;
    }

    setIsDeleting(true);
    try {
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          status: 'cancelled',
          cancellation_reason: cancellationReason.trim(),
          cancelled_by: userName,
          cancelled_at: new Date().toISOString()
        },
        { params: { token } }
      );

      setSuccessMessage('Ticket cancelled successfully');
      setShowSuccessModal(true);
      setShowCancelModal(false);
      fetchTicketDetails();
    } catch (error) {
      console.error('Error cancelling ticket:', error);
      alert('Failed to cancel ticket');
    } finally {
      setIsDeleting(false);
    }
  };

  // ===== CREATE NEW INSTANCE =====
  const openCreateInstanceModal = () => {
    const today = new Date();
    const nextMonth = new Date(today);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    setInstanceDate(nextMonth.toISOString().slice(0, 10));
    setShowCreateInstanceModal(true);
  };

  const handleCreateInstance = async () => {
    if (!instanceDate) {
      alert('Please select a date for the instance');
      return;
    }

    const selectedDate = new Date(instanceDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      alert('Cannot create instance for a past date. Please select today or a future date.');
      return;
    }

    setIsCreatingInstance(true);
    try {
      const response = await axios.post(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}/create-instance`,
        { instance_date: instanceDate },
        { params: { token } }
      );

      if (response.data && response.data.success) {
        setSuccessMessage(response.data.message || 'Instance created successfully!');
        setShowSuccessModal(true);
        setShowCreateInstanceModal(false);
        fetchInstances();
        fetchTicketDetails();
      }
    } catch (error) {
      console.error('Error creating instance:', error);
      alert(error.response?.data?.error || 'Failed to create instance');
    } finally {
      setIsCreatingInstance(false);
    }
  };

  // ===== HANDLE CLOSE RECURRING SERIES =====
  const handleCloseSeries = async () => {
    if (!closeSeriesReason.trim()) {
      alert('Please provide a reason for closing the entire series');
      return;
    }

    setIsDeleting(true);
    try {
      await axios.patch(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          status: 'cancelled',
          cancellation_reason: closeSeriesReason.trim(),
          cancelled_by: userName,
          cancelled_at: new Date().toISOString()
        },
        { params: { token } }
      );

      if (instances && instances.length > 0) {
        for (const instance of instances) {
          await axios.patch(
            `https://` + Host + `/maintenance/api/tickets/${instance.id}`,
            {
              status: 'cancelled',
              cancellation_reason: `Series closed: ${closeSeriesReason.trim()}`,
              cancelled_by: userName,
              cancelled_at: new Date().toISOString()
            },
            { params: { token } }
          );
        }
      }

      setSuccessMessage('Recurring series closed successfully');
      setShowSuccessModal(true);
      setShowCloseSeriesModal(false);
      fetchTicketDetails();
      fetchInstances();
    } catch (error) {
      console.error('Error closing series:', error);
      alert(error.response?.data?.error || 'Failed to close series');
    } finally {
      setIsDeleting(false);
    }
  };

  // ===== HANDLE PERMANENT DELETE (Manager only, removes DB record) =====
  const openDeleteModal = () => {
    if (!isManager) {
      alert('Only managers can permanently delete a ticket.');
      return;
    }
    setDeleteReason('');
    setShowDeleteModal(true);
  };

  const handleDeleteTicket = async () => {
    if (!isManager) {
      alert('Only managers can permanently delete a ticket.');
      return;
    }

    if (!deleteReason.trim()) {
      alert('Please provide a reason for deleting this ticket');
      return;
    }

    setIsDeletingRecord(true);
    try {
      await axios.delete(
        `https://` + Host + `/maintenance/api/tickets/${ticket.id}`,
        {
          params: { token },
          data: {
            deleted_by: userName,
            reason: deleteReason.trim()
          }
        }
      );

      setShowDeleteModal(false);
      alert('Ticket permanently deleted.');
      if (onBack) {
        onBack();
      } else {
        history.push('/maintenance');
      }
    } catch (error) {
      console.error('Error deleting ticket:', error);
      alert(error.response?.data?.error || 'Failed to delete ticket');
    } finally {
      setIsDeletingRecord(false);
    }
  };

  // ===== GET STATUS COLOR =====
  const getStatusColor = (status) => {
    const colors = {
      'open': '#f59e0b',
      'in_progress': '#3b82f6',
      'review': '#8b5cf6',
      'completed': '#22c55e',
      'closed': '#64748b',
      'cancelled': '#ef4444'
    };
    return colors[status] || '#94a3b8';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      'Critical': '#dc2626',
      'High': '#f59e0b',
      'Medium': '#3b82f6',
      'Low': '#22c55e'
    };
    return colors[priority] || '#94a3b8';
  };

  const getApprovalStatusColor = (status) => {
    const colors = {
      'Pending': '#f59e0b',
      'Approved': '#22c55e',
      'Rejected': '#dc2626'
    };
    return colors[status] || '#94a3b8';
  };

  // ===== RENDER ACTIVITY LOG =====
  const renderActivityLog = () => {
    if (!activityLog || activityLog.length === 0) {
      return (
        <div className="td-no-activity">
          <i className="fas fa-inbox"></i>
          <p>No activity recorded yet</p>
        </div>
      );
    }

    return activityLog.map((log, index) => {
      let details = null;
      try {
        if (log.details && typeof log.details === 'string') {
          details = JSON.parse(log.details);
        } else if (log.details) {
          details = log.details;
        }
      } catch (e) {
        details = { message: log.details };
      }

      return (
        <div key={index} className="td-activity-item">
          <div className="td-activity-icon">
            <i className="fas fa-circle"></i>
          </div>
          <div className="td-activity-content">
            <div className="td-activity-header">
              <span className="td-activity-user">{log.user || 'System'}</span>
              <span className="td-activity-time">{formatDateTime(log.timestamp || log.created_at)}</span>
            </div>
            <div className="td-activity-action">{log.action}</div>
            {details && (
              <div className="td-activity-details">
                {Object.keys(details).map((key) => (
                  <div key={key} className="td-activity-detail-item">
                    <span className="td-detail-key">{key}:</span>
                    <span className="td-detail-value">
                      {typeof details[key] === 'object'
                        ? JSON.stringify(details[key])
                        : details[key]}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  // ===== RENDER COMMENTS =====
  const renderComments = () => {
    if (!comments || comments.length === 0) {
      return (
        <div className="td-no-comments">
          <i className="fas fa-comment"></i>
          <p>No comments yet</p>
        </div>
      );
    }

    return comments.map((comment, index) => {
      const isHighlighted = index === comments.length - 1 && highlightedCommentId;

      return (
        <div
          key={index}
          className={`td-comment-item ${isHighlighted ? 'td-comment-highlighted' : ''}`}
        >
          <div className="td-comment-avatar">
            {comment.user ? comment.user.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="td-comment-content">
            <div className="td-comment-header">
              <span className="td-comment-user">{comment.user || 'Unknown'}</span>
              <span className="td-comment-time">{formatDateTime(comment.created_at)}</span>
            </div>
            <p className="td-comment-text">{comment.comment}</p>
            {isHighlighted && (
              <div className="td-comment-new-badge">
                <i className="fas fa-star"></i> New
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  // ===== RENDER RECURRING INSTANCES =====
  const renderInstances = () => {
    if (!ticket?.is_recurring) return null;

    if (isLoadingInstances) {
      return (
        <div className="td-loading-small">
          <div className="td-spinner-small"></div>
          <span>Loading instances...</span>
        </div>
      );
    }

    if (!instances || instances.length === 0) {
      return (
        <div className="td-no-instances">
          <i className="fas fa-calendar"></i>
          <p>No instances found for this recurring ticket</p>
        </div>
      );
    }

    return (
      <div className="td-instances-list">
        <div className="td-instances-header">
          <span className="td-instances-title">Instance History</span>
          <span className="td-instances-count">{instances.length} instances</span>
        </div>
        {instances.map((instance, index) => {
          const isCurrent = instance.id == ticketId;
          const statusColor = getStatusColor(instance.status);
          const isApproved = instance.approval_status === 'Approved' || instance.approval_status === 'approved';

          return (
            <div
              key={index}
              className={`td-instance-item ${isCurrent ? 'td-instance-current' : ''}`}
              onClick={() => {
                if (!isCurrent) {
                  history.push(`/maintenance/ticket/${instance.id}`);
                }
              }}
            >
              <div className="td-instance-info">
                <span className="td-instance-date">
                  {instance.recurrence_instance_date ?
                    formatDate(instance.recurrence_instance_date) :
                    'N/A'}
                </span>
                <span className="td-instance-ticket">
                  {instance.ticket_number}
                </span>
              </div>
              <div className="td-instance-status">
                <span className="td-instance-status-badge" style={{ background: statusColor }}>
                  {instance.status || 'N/A'}
                </span>
                <span className="td-instance-approval-badge" style={{
                  background: isApproved ? '#22c55e' : '#f59e0b',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '10px'
                }}>
                  {isApproved ? '✓ Approved' : '⏳ Pending'}
                </span>
                {isCurrent && (
                  <span className="td-instance-current-badge">Current</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // ===== RENDER PURCHASE LIST =====
  const renderPurchaseList = () => {
    if (isLoadingPurchases) {
      return (
        <div className="td-loading-small">
          <div className="td-spinner-small"></div>
          <span>Loading purchase requests...</span>
        </div>
      );
    }

    if (purchaseRequests.length === 0) {
      return (
        <div className="td-no-purchases">
          <i className="fas fa-box-open"></i>
          <p>No purchase requests for this ticket</p>
        </div>
      );
    }

    return (
      <div className="td-purchase-list">
        {purchaseRequests.map((req, index) => {
          const ticketNo = req.Ticket_No || req.ticket_no;

          return (
            <div
              key={index}
              className="td-purchase-item"
              onClick={() => {
                if (ticketNo) {
                  viewPurchaseDetail(ticketNo);
                } else {
                  alert('This purchase request has no Ticket Number');
                }
              }}
            >
              <div className="td-purchase-info">
                <span className="td-purchase-part">{req.Part_No || 'N/A'}</span>
                <span className="td-purchase-desc">{req.Item_Desc || 'N/A'}</span>
              </div>
              <div className="td-purchase-meta">
                <span className="td-purchase-qty">Qty: {req.Qty || 'N/A'}</span>
                <span className="td-purchase-status">
                  Status: {req.Status || 'N/A'}
                </span>
                <span className="td-purchase-date">
                  {req.Requested_Date ?
                    formatDate(req.Requested_Date) :
                    'N/A'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // ===== RENDER PURCHASE MODAL =====
  const renderPurchaseModal = () => {
    const uniqueBrands = getUniqueValues('Brand');
    const uniqueVendors = getUniqueValues('Vendor');
    const uniqueUnits = getUniqueValues('Unit');
    const uniquePartNos = getUniqueValues('Part_No');

    const isApproved = ticket?.approval_status === 'Approved' || ticket?.approval_status === 'approved';

    return (
      <div className="purchase-request-modal" onClick={() => setShowPurchaseModal(false)}>
        <div className="purchase-request-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>
              <i className="fas fa-shopping-cart"></i>
              Create Purchase Request
              {ticketId && <span className="ticket-badge">Ticket: {ticketId}</span>}
            </h3>
            <button className="close-btn" onClick={() => setShowPurchaseModal(false)}>×</button>
          </div>

          {!isApproved && (
            <div className="td-warning-banner" style={{ background: '#fff3cd', padding: '12px', borderRadius: '8px', marginBottom: '16px', borderLeft: '4px solid #ffc107' }}>
              <i className="fas fa-exclamation-triangle" style={{ color: '#856404' }}></i>
              <span style={{ color: '#856404', marginLeft: '8px' }}>
                ⚠️ Purchase requests can only be created for <strong>approved</strong> tickets.
                Please wait for manager approval.
              </span>
            </div>
          )}

          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col" style={{ width: "30%" }}>FIELD</th>
                <th scope="col" style={{ width: "70%" }}>INPUT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TICKET NO</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%", backgroundColor: "#f3f4f6" }}
                    value={ticketId || ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <td>REQUEST DATE</td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    name="Request_date"
                    style={{ width: "100%" }}
                    value={purchaseFormData.Request_date}
                    onChange={handlePurchaseChange}
                  />
                </td>
              </tr>
              <tr>
                <td>NAME</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    style={{ width: "100%", backgroundColor: "#f3f4f6" }}
                    value={purchaseFormData.name}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <td>PART NO</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="Part_No"
                    style={{ width: "100%" }}
                    value={purchaseFormData.Part_No}
                    onChange={handlePartNoChange}
                    list="partNoList"
                    placeholder="Select or type part number"
                    disabled={!isApproved}
                  />
                  <datalist id="partNoList">
                    <option value="" />
                    {uniquePartNos.map((part, index) => (
                      <option key={index} value={part}>{part}</option>
                    ))}
                  </datalist>
                  {purchaseFormData.Part_No && purchaseData.find(item => item.Part_No === purchaseFormData.Part_No) && (
                    <small style={{ color: '#22c55e', display: 'block', marginTop: '4px' }}>
                      <i className="fas fa-check-circle"></i> Previous record found - auto-filled related fields
                    </small>
                  )}
                </td>
              </tr>
              <tr>
                <td>ITEM DESCRIPTION</td>
                <td>
                  <textarea
                    className="form-control"
                    name="item_description"
                    rows="3"
                    style={{ width: "100%" }}
                    value={purchaseFormData.item_description}
                    onChange={handlePurchaseChange}
                    placeholder="Item description will auto-fill when part number is selected"
                    disabled={!isApproved}
                  />
                </td>
              </tr>
              <tr>
                <td>BRAND</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="brand"
                    style={{ width: "100%" }}
                    value={purchaseFormData.brand}
                    onChange={handlePurchaseChange}
                    list="brandList"
                    placeholder="Auto-fills when part number is selected"
                    disabled={!isApproved}
                  />
                  <datalist id="brandList">
                    <option value="" />
                    {uniqueBrands.map((brand, index) => (
                      <option key={index} value={brand}>{brand}</option>
                    ))}
                  </datalist>
                </td>
              </tr>
              <tr>
                <td>QUANTITY</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    name="qty"
                    style={{ width: "100%" }}
                    value={purchaseFormData.qty}
                    onChange={handlePurchaseChange}
                    placeholder="Enter quantity"
                    min="1"
                    disabled={!isApproved}
                  />
                </td>
              </tr>
              <tr>
                <td>UNIT</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="unit"
                    style={{ width: "100%" }}
                    value={purchaseFormData.unit}
                    onChange={handlePurchaseChange}
                    list="unitList"
                    placeholder="Auto-fills when part number is selected"
                    disabled={!isApproved}
                  />
                  <datalist id="unitList">
                    <option value="" />
                    {uniqueUnits.map((unit, index) => (
                      <option key={index} value={unit}>{unit}</option>
                    ))}
                  </datalist>
                </td>
              </tr>
              <tr>
                <td>VENDOR</td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="vendor"
                    style={{ width: "100%" }}
                    value={purchaseFormData.vendor}
                    onChange={handlePurchaseChange}
                    list="vendorList"
                    placeholder="Auto-fills when part number is selected"
                    disabled={!isApproved}
                  />
                  <datalist id="vendorList">
                    <option value="" />
                    {uniqueVendors.map((vendor, index) => (
                      <option key={index} value={vendor}>{vendor}</option>
                    ))}
                  </datalist>
                </td>
              </tr>
              <tr>
                <td>REQUIRED BEFORE</td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    name="required_before"
                    style={{ width: "100%" }}
                    value={purchaseFormData.required_before}
                    onChange={handlePurchaseChange}
                    disabled={!isApproved}
                  />
                </td>
              </tr>
              <tr>
                <td>COMMENTS</td>
                <td>
                  <textarea
                    className="form-control"
                    name="comments"
                    rows="3"
                    style={{ width: "100%" }}
                    value={purchaseFormData.comments}
                    onChange={handlePurchaseChange}
                    placeholder="Add any additional comments"
                    disabled={!isApproved}
                  />
                </td>
              </tr>
              <tr>
                <td>ATTACHMENTS</td>
                <td>
                  <input
                    type="file"
                    className="form-control"
                    style={{ width: "100%" }}
                    multiple
                    onChange={handlePurchaseFileChange}
                    disabled={!isApproved}
                  />
                  {files.length > 0 && (
                    <div className="file-list">
                      <ul>
                        {files.map((file, index) => (
                          <li key={index}>
                            <i className="fas fa-file"></i> {file.name} ({(file.size / 1024).toFixed(1)} KB)
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2" style={{ textAlign: "right", padding: "15px" }}>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPurchaseModal(false)}
                    style={{ marginRight: "10px" }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handlePurchaseSubmit}
                    disabled={isSubmittingPurchase || !isApproved}
                  >
                    {isSubmittingPurchase ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                      </>
                    ) : (
                      'Submit Request'
                    )}
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  // ===== RENDER ACTION BUTTONS =====
  const renderActionButtons = () => {
    if (!ticket) return null;

    const status = ticket.status;
    const isCancelled = status === 'cancelled';
    const isClosed = status === 'closed';
    const isPendingCompletion = ticket.approval_type === 'completion' && ticket.approval_status === 'Pending';
    const isOverdue = isDateOverdue(ticket);
    const isApproved = ticket.approval_status === 'Approved' || ticket.approval_status === 'approved';
    const isRecurringParent = ticket.is_recurring && !ticket.recurrence_parent_id;
    const isRecurringInstance = ticket.is_recurring && ticket.recurrence_parent_id;
    const isCompletionRejected = ticket.approval_status === 'Rejected' && ticket.approval_type === 'completion';
    const isModificationPending = ticket.approval_type === 'modification' && ticket.approval_status === 'Pending';

    if (isCancelled || isClosed) {
      let message = `This ticket is ${status}.`;
      if (isRecurringInstance) {
        message += ` This instance has been ${status}. New instances will be created for future periods.`;
      }
      return (
        <div className="td-actions">
          <div className="td-action-note">
            <i className="fas fa-info-circle"></i>
            <span>{message}</span>
          </div>
          {isRecurringInstance && (
            <button
              className="td-action-btn td-btn-secondary"
              onClick={() => fetchInstances()}
              style={{ marginTop: '8px' }}
            >
              <i className="fas fa-sync"></i> View All Instances
            </button>
          )}
          {isManager && (
            <button
              className="td-action-btn td-btn-danger"
              onClick={openDeleteModal}
              style={{ background: '#7f1d1d', marginTop: '8px' }}
            >
              <i className="fas fa-trash-alt"></i> Delete Ticket Permanently
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="td-actions">
        {isMaintenance && (
          <div className="td-status-actions">
            {/* Edit Ticket Button */}
            {(isManager || isMaintenance) && !isRecurringParent && (
              <button
                className="td-action-btn td-btn-info"
                onClick={openEditModal}
                style={{ background: '#0d6efd' }}
              >
                <i className="fas fa-edit"></i> Edit Ticket
              </button>
            )}

            {isModificationPending && (
              <div className="td-action-note" style={{ color: '#f59e0b', padding: '8px', background: '#fff3cd', borderRadius: '6px', marginBottom: '8px' }}>
                <i className="fas fa-clock"></i>
                <span>Modification request pending manager approval</span>
              </div>
            )}

            {/* Reopen button when completion is rejected */}
            {isCompletionRejected && isMaintenance && !isRecurringParent && (
              <button
                className="td-action-btn td-btn-warning"
                onClick={openReopenModal}
                style={{ background: '#ffc107', color: '#000' }}
              >
                <i className="fas fa-undo"></i> Reopen Ticket
              </button>
            )}

            {isRecurringParent && (
              <div className="td-action-note" style={{ color: '#0d6efd', padding: '8px', background: '#cfe2ff', borderRadius: '6px', marginBottom: '8px' }}>
                <i className="fas fa-sync-alt"></i>
                <span>This is a recurring ticket template. Work on individual instances below.</span>
              </div>
            )}

            {status === 'open' && !isApproved && !isRecurringParent && (
              <div className="td-action-note" style={{ color: '#f59e0b', padding: '8px', background: '#fff3cd', borderRadius: '6px' }}>
                <i className="fas fa-clock"></i>
                <span>Waiting for manager approval. Start Work / Mark Complete will be available after approval.</span>
              </div>
            )}

            {isRecurringInstance && status === 'open' && isApproved && (
              <button
                className="td-action-btn td-btn-warning"
                onClick={() => updateStatus('in_progress')}
                style={{ background: '#ffc107', color: '#000' }}
              >
                <i className="fas fa-play"></i> Start Work
              </button>
            )}

            {status === 'open' && isApproved && !isRecurringInstance && !isRecurringParent && (
              <button
                className="td-action-btn td-btn-warning"
                onClick={() => updateStatus('in_progress')}
                style={{ background: '#ffc107', color: '#000' }}
              >
                <i className="fas fa-play"></i> Start Work
              </button>
            )}

            {isRecurringInstance && status === 'in_progress' && (
              <button
                className="td-action-btn td-btn-warning"
                onClick={openCompleteModal}
                style={{ background: '#ffc107', color: '#000' }}
              >
                <i className="fas fa-check-circle"></i> Close Current Instance
                {isOverdue && (
                  <span className="td-overdue-warning" style={{ marginLeft: '4px', fontSize: '11px', color: '#dc3545' }}>
                    (Overdue)
                  </span>
                )}
              </button>
            )}

            {isRecurringInstance && (status === 'review' || status === 'completed') && (
              <button
                className="td-action-btn td-btn-success"
                onClick={() => {
                  if (status === 'review') {
                    updateStatus('completed');
                  } else if (status === 'completed') {
                    if (isManager) {
                      approveCompletion();
                    } else {
                      alert('Instance is completed. Please wait for manager approval to close it.');
                    }
                  }
                }}
              >
                <i className="fas fa-check-double"></i>
                {status === 'review' ? 'Complete Instance' : 'Close Instance'}
              </button>
            )}

            {status === 'in_progress' && !isRecurringInstance && !isRecurringParent && (
              <button
                className="td-action-btn td-btn-success"
                onClick={openCompleteModal}
              >
                <i className="fas fa-check"></i> Mark Complete
                {isOverdue && (
                  <span className="td-overdue-warning" style={{ marginLeft: '4px', fontSize: '11px' }}>
                    (Overdue)
                  </span>
                )}
              </button>
            )}

            {status === 'review' && !isRecurringInstance && !isRecurringParent && isManager && (
              <button
                className="td-action-btn td-btn-success"
                onClick={() => updateStatus('completed')}
              >
                <i className="fas fa-check"></i> Approve & Complete
              </button>
            )}
          </div>
        )}

        {isPendingCompletion && isManager && (
          <div className="td-status-actions">
            <button
              className="td-action-btn td-btn-success"
              onClick={approveCompletion}
            >
              <i className="fas fa-check"></i> Approve Completion
            </button>
            <button
              className="td-action-btn td-btn-danger"
              onClick={rejectCompletion}
            >
              <i className="fas fa-times"></i> Reject Completion
            </button>
          </div>
        )}

        {isManager && !isRecurringParent && (
          <button
            className="td-action-btn td-btn-info"
            onClick={() => setShowAssigneeModal(true)}
          >
            <i className="fas fa-user-plus"></i> Assign Ticket
          </button>
        )}

        {isManager && !isRecurringParent && (
          <button
            className="td-action-btn td-btn-danger"
            onClick={() => setShowCancelModal(true)}
          >
            <i className="fas fa-ban"></i> Cancel Ticket
          </button>
        )}

        {isManager && isRecurringParent && (
          <button
            className="td-action-btn td-btn-success"
            onClick={openCreateInstanceModal}
            style={{ background: '#28a745' }}
          >
            <i className="fas fa-plus-circle"></i> Create Instance
          </button>
        )}

        {isManager && isRecurringParent && (
          <button
            className="td-action-btn td-btn-danger"
            onClick={() => setShowCloseSeriesModal(true)}
            style={{ background: '#dc3545' }}
          >
            <i className="fas fa-stop-circle"></i> Close Entire Series
          </button>
        )}

        {isManager && (
          <button
            className="td-action-btn td-btn-danger"
            onClick={openDeleteModal}
            style={{ background: '#7f1d1d' }}
          >
            <i className="fas fa-trash-alt"></i> Delete Ticket Permanently
          </button>
        )}
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="td-loading">
        <div className="td-loading-spinner"></div>
        <p>Loading ticket details...</p>
      </div>
    );
  }

  if (!ticket) {
    return (
      <div className="td-error">
        <i className="fas fa-exclamation-triangle"></i>
        <h3>Ticket not found</h3>
        <p>The ticket you're looking for doesn't exist or you don't have permission to view it.</p>
        <button className="td-btn td-btn-primary" onClick={() => history.push('/maintenance')}>
          Back to Dashboard
        </button>
      </div>
    );
  }

  const dateInfo = getDateInfo(ticket);
  const isPendingApproval = ticket.approval_status === 'Pending';
  const isPendingCompletion = ticket.approval_type === 'completion' && ticket.approval_status === 'Pending';
  const isModificationPending = ticket.approval_type === 'modification' && ticket.approval_status === 'Pending';
  const isOverdue = isDateOverdue(ticket);
  const isApproved = ticket.approval_status === 'Approved' || ticket.approval_status === 'approved';
  const isRecurringParent = ticket.is_recurring && !ticket.recurrence_parent_id;
  const isCompletionRejected = ticket.approval_status === 'Rejected' && ticket.approval_type === 'completion';

  return (
    <div className="td-container">
      {/* Header */}
      <div className="td-header">
        <div className="td-header-left">
          <button className="td-back-btn" onClick={onBack || (() => history.push('/maintenance'))}>
            <i className="fas fa-arrow-left"></i> Back
          </button>
          <h1 className="td-title">
            {ticket.ticket_number}
            {ticket.is_recurring && (
              <span className="td-recurring-badge">
                <i className="fas fa-sync-alt"></i> Recurring
                {ticket.recurrence_parent_id && (
                  <span className="td-instance-badge" style={{ marginLeft: '6px', fontSize: '11px' }}>
                    Instance: {formatDate(ticket.recurrence_instance_date)}
                  </span>
                )}
                {isRecurringParent && (
                  <span className="td-parent-badge" style={{ marginLeft: '6px', fontSize: '11px', background: '#0d6efd' }}>
                    Parent
                  </span>
                )}
              </span>
            )}
            {isPendingApproval && isModificationPending && (
              <span className="td-pending-badge" style={{ background: '#dbeafe', color: '#1e40af' }}>
                <i className="fas fa-clock"></i> Modification Pending
              </span>
            )}
            {isPendingCompletion && (
              <span className="td-pending-badge" style={{ background: '#dbeafe', color: '#1e40af' }}>
                <i className="fas fa-clock"></i> Pending Completion Approval
              </span>
            )}
            {isCompletionRejected && (
              <span className="td-rejected-badge" style={{ background: '#fee2e2', color: '#991b1b' }}>
                <i className="fas fa-times-circle"></i> Completion Rejected
              </span>
            )}
            {isOverdue && ticket.status !== 'completed' && ticket.status !== 'closed' && ticket.status !== 'cancelled' && (
              <span className="td-overdue-badge" style={{ background: '#fee2e2', color: '#991b1b', padding: '4px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: '600' }}>
                <i className="fas fa-exclamation-triangle"></i> Overdue
              </span>
            )}
          </h1>
        </div>
        <div className="td-header-right">
          <span className="td-status-badge" style={{ background: getStatusColor(ticket.status) }}>
            {ticket.status?.replace(/_/g, ' ') || 'Unknown'}
          </span>
          <span className="td-priority-badge" style={{ background: getPriorityColor(ticket.priority) }}>
            {ticket.priority || 'Low'}
          </span>
          <span
            className="td-approval-badge"
            style={{ background: getApprovalStatusColor(ticket.approval_status) }}
          >
            {ticket.approval_status || 'Pending'}
          </span>
        </div>
      </div>

      {/* Pending Modification Banner */}
      {isModificationPending && pendingChanges && (
        <div className="td-pending-modification-banner" style={{
          background: '#fff3cd',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          borderLeft: '4px solid #ffc107',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}>
          <div>
            <i className="fas fa-clock" style={{ color: '#856404', marginRight: '8px' }}></i>
            <strong style={{ color: '#856404' }}>Pending Modification Request</strong>
            <span style={{ color: '#856404', marginLeft: '8px' }}>
              Changes have been submitted for manager approval
            </span>
          </div>
          <div style={{ fontSize: '13px', color: '#856404' }}>
            <span>Reason: {pendingChanges.reason || 'No reason provided'}</span>
          </div>
        </div>
      )}

      {/* Completion Rejected Banner */}
      {isCompletionRejected && (
        <div className="td-completion-rejected-banner" style={{
          background: '#fee2e2',
          padding: '16px 20px',
          borderRadius: '8px',
          marginBottom: '16px',
          borderLeft: '4px solid #dc3545',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '12px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
            <i className="fas fa-times-circle" style={{ color: '#991b1b', fontSize: '20px' }}></i>
            <div>
              <strong style={{ color: '#991b1b', display: 'block' }}>Completion Rejected</strong>
              <span style={{ color: '#991b1b', fontSize: '14px' }}>
                Manager has rejected the completion. The ticket is currently in <strong>{ticket.status}</strong> status.
                Please review the feedback and choose an action below.
              </span>
              {ticket.manager_comments && (
                <div style={{
                  marginTop: '8px',
                  padding: '8px 12px',
                  background: 'rgba(255,255,255,0.5)',
                  borderRadius: '4px',
                  fontSize: '13px',
                  color: '#991b1b'
                }}>
                  <strong>Feedback:</strong> {ticket.manager_comments}
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {isMaintenance && !isRecurringParent && (
              <>
                <button
                  className="td-btn td-btn-warning"
                  onClick={openReopenModal}
                  style={{
                    background: '#ffc107',
                    color: '#000',
                    padding: '8px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  <i className="fas fa-undo"></i> Reopen & Fix
                </button>
                <button
                  className="td-btn td-btn-secondary"
                  onClick={() => {
                    if (window.confirm('Are you sure you want to keep the ticket in its current state?')) {
                      setSuccessMessage('Ticket kept in current state. You can reopen it later if needed.');
                      setShowSuccessModal(true);
                    }
                  }}
                  style={{
                    background: '#6c757d',
                    color: '#fff',
                    padding: '8px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  <i className="fas fa-arrow-right"></i> Keep as is
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Overdue Warning Popup */}
      {showOverdueWarning && (
        <div className="td-overdue-warning-popup">
          <div className="td-overdue-warning-content">
            <div className="td-overdue-warning-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <div className="td-overdue-warning-text">
              <h4>⚠️ Warning</h4>
              <p>{overdueMessage}</p>
            </div>
            <div className="td-overdue-warning-actions">
              <button
                className="td-btn td-btn-primary td-btn-sm"
                onClick={openEditModal}
              >
                <i className="fas fa-edit"></i> Edit Ticket
              </button>
              <button
                className="td-btn td-btn-secondary td-btn-sm"
                onClick={() => setShowOverdueWarning(false)}
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Content Grid - Two Column Layout */}
      <div className="td-content-grid td-layout-two-column">
        {/* Left Column */}
        <div className="td-left-column">
          {/* Issue Description */}
          <div className="td-card">
            <div className="td-card-header">
              <h3><i className="fas fa-info-circle"></i> Issue Description</h3>
            </div>
            <div className="td-card-body">
              <p className={`td-description ${hasPendingChange('issue_description') ? 'td-pending-change-field' : ''}`}>
                {ticket.issue_description || 'No description provided'}
                {hasPendingChange('issue_description') && (
                  <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                    Pending: {getPendingChangeValue('issue_description')}
                  </span>
                )}
              </p>
            </div>
          </div>

          {/* Ticket Details */}
          <div className="td-card">
            <div className="td-card-header">
              <h3><i className="fas fa-tasks"></i> Ticket Details</h3>
            </div>
            <div className="td-card-body">
              <div className="td-detail-grid">
                <div className="td-detail-item">
                  <label>Type</label>
                  <span className={`td-detail-value ${hasPendingChange('type') ? 'td-pending-change-field' : ''}`}>
                    {ticket.type === 'prescheduled' ? 'Pre-scheduled' : 'Emergent'}
                    {hasPendingChange('type') && (
                      <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                        → {getPendingChangeValue('type') === 'prescheduled' ? 'Pre-scheduled' : 'Emergent'}
                      </span>
                    )}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Category</label>
                  <span className={`td-detail-value ${hasPendingChange('maintenance_category') ? 'td-pending-change-field' : ''}`}>
                    {ticket.maintenance_category || 'N/A'}
                    {hasPendingChange('maintenance_category') && (
                      <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                        → {getPendingChangeValue('maintenance_category')}
                      </span>
                    )}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Priority</label>
                  <span className={`td-detail-value ${hasPendingChange('priority') ? 'td-pending-change-field' : ''}`}>
                    {ticket.priority || 'N/A'}
                    {hasPendingChange('priority') && (
                      <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                        → {getPendingChangeValue('priority')}
                      </span>
                    )}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Requested By</label>
                  <span className="td-detail-value">{ticket.requested_by || 'Unknown'}</span>
                </div>
                <div className="td-detail-item">
                  <label>Request Date</label>
                  <span className="td-detail-value">{formatDate(ticket.request_date)}</span>
                </div>
                <div className="td-detail-item">
                  <label>Assigned To</label>
                  <span className="td-detail-value">{ticket.assigned_to || 'Unassigned'}</span>
                </div>
                <div className="td-detail-item">
                  <label>Assigned Date</label>
                  <span className="td-detail-value">{formatDate(ticket.assigned_date)}</span>
                </div>
                <div className="td-detail-item">
                  <label>Approved By</label>
                  <span className="td-detail-value">{ticket.approved_by || 'N/A'}</span>
                </div>
                <div className="td-detail-item">
                  <label>Approval Date</label>
                  <span className="td-detail-value">{formatDate(ticket.approval_date)}</span>
                </div>

                {ticket.is_recurring && ticket.recurrence_instance_date && (
                  <div className="td-detail-item">
                    <label>Instance Date</label>
                    <span className="td-detail-value">{formatDate(ticket.recurrence_instance_date)}</span>
                  </div>
                )}

                <div className="td-detail-item td-date-item">
                  <label>{dateInfo.label}</label>
                  <div className="td-date-display">
                    <span className={`td-detail-value ${hasPendingChange(dateInfo.field) ? 'td-pending-change-field' : ''}`} style={{ color: isOverdue ? '#dc2626' : '#0f172a' }}>
                      {formatDate(ticket[dateInfo.field])}
                      {isOverdue && (
                        <span className="td-overdue-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#dc2626', fontWeight: '700' }}>
                          ⚠️ OVERDUE
                        </span>
                      )}
                      {hasPendingChange(dateInfo.field) && (
                        <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                          → {formatDate(getPendingChangeValue(dateInfo.field))}
                        </span>
                      )}
                    </span>
                    {(isManager || isMaintenance) && !isRecurringParent && (
                      <button
                        className="td-edit-date-btn"
                        onClick={openEditModal}
                        title={`Edit ${dateInfo.label}`}
                      >
                        <i className="fas fa-pen"></i>
                      </button>
                    )}
                  </div>
                  {dateInfo.hint && (
                    <div className="td-date-hint">
                      <i className="fas fa-info-circle"></i> {dateInfo.hint}
                    </div>
                  )}
                </div>

                {ticket.is_recurring && ticket.recurrence_type && ticket.recurrence_type !== 'none' && (
                  <>
                    <div className="td-detail-item">
                      <label>Recurrence</label>
                      <span className="td-detail-value">
                        {ticket.recurrence_type.charAt(0).toUpperCase() + ticket.recurrence_type.slice(1)}
                        {ticket.recurrence_day && ` (${ticket.recurrence_day})`}
                        {ticket.recurrence_date && ` on day ${ticket.recurrence_date}`}
                      </span>
                    </div>
                    {ticket.schedule_end_date && (
                      <div className="td-detail-item">
                        <label>Schedule End</label>
                        <span className={`td-detail-value ${hasPendingChange('schedule_end_date') ? 'td-pending-change-field' : ''}`}>
                          {formatDate(ticket.schedule_end_date)}
                          {hasPendingChange('schedule_end_date') && (
                            <span className="td-pending-badge-small" style={{ marginLeft: '8px', fontSize: '11px', color: '#856404', background: '#fff3cd', padding: '2px 8px', borderRadius: '12px' }}>
                              → {formatDate(getPendingChangeValue('schedule_end_date'))}
                            </span>
                          )}
                        </span>
                      </div>
                    )}
                  </>
                )}

                {ticket.completed_by && (
                  <div className="td-detail-item">
                    <label>Completed By</label>
                    <span className="td-detail-value">{ticket.completed_by}</span>
                  </div>
                )}
                {ticket.completed_at && !ticket.completed_at.startsWith('0000') && !isNaN(new Date(ticket.completed_at).getTime()) && (
                  <div className="td-detail-item">
                    <label>Completed At</label>
                    <span className="td-detail-value">{formatDateTime(ticket.completed_at)}</span>
                  </div>
                )}
                {ticket.closed_by && (
                  <div className="td-detail-item">
                    <label>Closed By</label>
                    <span className="td-detail-value">{ticket.closed_by}</span>
                  </div>
                )}
                {ticket.closed_at && (
                  <div className="td-detail-item">
                    <label>Closed At</label>
                    <span className="td-detail-value">{formatDateTime(ticket.closed_at)}</span>
                  </div>
                )}
                {ticket.cancelled_by && (
                  <div className="td-detail-item">
                    <label>Cancelled By</label>
                    <span className="td-detail-value">{ticket.cancelled_by}</span>
                  </div>
                )}
                {ticket.cancelled_at && (
                  <div className="td-detail-item">
                    <label>Cancelled At</label>
                    <span className="td-detail-value">{formatDateTime(ticket.cancelled_at)}</span>
                  </div>
                )}

                {ticket.delay_reason && (
                  <div className="td-detail-item" style={{ gridColumn: '1 / -1' }}>
                    <label>Delay Reason</label>
                    <span className="td-detail-value" style={{ color: '#dc2626' }}>{ticket.delay_reason}</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Manager Comments */}
          {ticket.manager_comments && (
            <div className="td-card">
              <div className="td-card-header">
                <h3><i className="fas fa-comment-dots"></i> Manager Comments</h3>
              </div>
              <div className="td-card-body">
                <p className="td-manager-comments">{ticket.manager_comments}</p>
              </div>
            </div>
          )}

          {/* Recurring Instances Section */}
          {ticket.is_recurring && (
            <div className="td-card td-instances-card">
              <div className="td-card-header">
                <h3><i className="fas fa-calendar-alt"></i> Instances</h3>
                <button
                  className="td-btn td-btn-sm td-btn-secondary"
                  onClick={() => setShowInstances(!showInstances)}
                >
                  <i className={`fas fa-chevron-${showInstances ? 'up' : 'down'}`}></i>
                </button>
              </div>
              {showInstances && (
                <div className="td-card-body">
                  {renderInstances()}
                </div>
              )}
            </div>
          )}

          {/* Purchase Requests Section */}
          <div className="td-card td-purchase-card">
            <div className="td-card-header">
              <h3><i className="fas fa-shopping-cart"></i> Purchase Requests</h3>
              <div className="td-card-actions">
                {(isManager || isMaintenance) &&
                  ticket.status !== 'cancelled' &&
                  ticket.status !== 'closed' &&
                  isApproved &&
                  !isRecurringParent && (
                    <button
                      className="td-btn td-btn-sm td-btn-primary"
                      onClick={() => setShowPurchaseModal(true)}
                    >
                      <i className="fas fa-plus"></i> New
                    </button>
                  )}
                <button
                  className="td-btn td-btn-sm td-btn-secondary"
                  onClick={() => setShowPurchaseList(!showPurchaseList)}
                >
                  <i className={`fas fa-chevron-${showPurchaseList ? 'up' : 'down'}`}></i>
                </button>
              </div>
            </div>
            {showPurchaseList && (
              <div className="td-card-body">
                {renderPurchaseList()}
              </div>
            )}
          </div>
        </div>

        {/* Right Column */}
        <div className="td-right-column">
          {/* Actions Card */}
          <div className="td-card td-actions-card">
            <div className="td-card-header">
              <h3><i className="fas fa-bolt"></i> Actions</h3>
            </div>
            <div className="td-card-body">
              {renderActionButtons()}
            </div>
          </div>

          {/* Comments Section */}
          <div className="td-card td-comments-card">
            <div className="td-card-header">
              <h3><i className="fas fa-comments"></i> Comments</h3>
              <span className="td-comment-count">{comments?.length || 0}</span>
            </div>
            <div className="td-card-body">
              <div className="td-comments-list">
                {renderComments()}
              </div>

              <form className="td-comment-form" onSubmit={handleCommentSubmit}>
                <textarea
                  ref={commentInputRef}
                  className="td-comment-input"
                  placeholder="Add a comment..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  rows="3"
                  disabled={isSubmittingComment}
                />
                <button
                  type="submit"
                  className="td-comment-submit"
                  disabled={isSubmittingComment || !comment.trim()}
                >
                  {isSubmittingComment ? (
                    <>
                      <span className="td-spinner"></span> Sending...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i> Post Comment
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* Activity Log */}
          <div className="td-card td-activity-card">
            <div className="td-card-header">
              <h3><i className="fas fa-history"></i> Activity Log</h3>
              <span className="td-activity-count">{activityLog?.length || 0}</span>
            </div>
            <div className="td-card-body td-activity-body">
              {renderActivityLog()}
            </div>
          </div>
        </div>
      </div>

      {/* ===== EDIT TICKET MODAL ===== */}
      {showEditModal && (
        <div className="td-modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="td-modal td-modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3>
                <i className="fas fa-edit"></i>
                Edit Ticket - {ticket.ticket_number}
              </h3>
              <button className="td-modal-close" onClick={() => setShowEditModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-info">
                <p className="td-modal-hint" style={{
                  background: '#e8f4fd',
                  padding: '10px 14px',
                  borderRadius: '6px',
                  marginBottom: '16px'
                }}>
                  <i className="fas fa-info-circle" style={{ color: '#0d6efd' }}></i>
                  {isManager
                    ? ' As a manager, your changes will be applied immediately.'
                    : ' Your changes will be sent to the manager for approval. Only changed fields will be submitted.'}
                </p>
              </div>

              {/* Issue Description - Pre-filled */}
              <div className="td-form-group">
                <label>Issue Description</label>
                <textarea
                  className="td-form-textarea"
                  rows="3"
                  value={editFormData.issue_description || ''}
                  onChange={(e) => setEditFormData(prev => ({ ...prev, issue_description: e.target.value }))}
                  placeholder="Describe the issue..."
                  style={{
                    borderColor: editFormData.issue_description !== ticket.issue_description ? '#0d6efd' : '#d1d5db',
                    borderWidth: editFormData.issue_description !== ticket.issue_description ? '2px' : '1px'
                  }}
                />
                {editFormData.issue_description !== ticket.issue_description && (
                  <small style={{ color: '#0d6efd' }}>
                    <i className="fas fa-pen"></i> Changed from: "{ticket.issue_description || 'No description'}"
                  </small>
                )}
              </div>

              {/* Type and Priority - Pre-filled */}
              <div className="td-form-row">
                <div className="td-form-group">
                  <label>Type</label>
                  <select
                    className="td-form-select"
                    value={editFormData.type || 'emergent'}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, type: e.target.value }))}
                    style={{
                      borderColor: editFormData.type !== ticket.type ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.type !== ticket.type ? '2px' : '1px'
                    }}
                  >
                    <option value="emergent">Emergent</option>
                    <option value="prescheduled">Pre-scheduled</option>
                  </select>
                  {editFormData.type !== ticket.type && (
                    <small style={{ color: '#0d6efd' }}>
                      <i className="fas fa-pen"></i> Changed from: {ticket.type === 'prescheduled' ? 'Pre-scheduled' : 'Emergent'}
                    </small>
                  )}
                </div>
                <div className="td-form-group">
                  <label>Priority</label>
                  <select
                    className="td-form-select"
                    value={editFormData.priority || 'Medium'}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, priority: e.target.value }))}
                    style={{
                      borderColor: editFormData.priority !== ticket.priority ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.priority !== ticket.priority ? '2px' : '1px'
                    }}
                  >
                    <option value="Critical">Critical</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                  {editFormData.priority !== ticket.priority && (
                    <small style={{ color: '#0d6efd' }}>
                      <i className="fas fa-pen"></i> Changed from: {ticket.priority || 'Medium'}
                    </small>
                  )}
                </div>
              </div>

              {/* Category - Pre-filled */}
              <div className="td-form-group">
                <label>Category</label>
                <input
                  type="text"
                  className="td-form-input"
                  value={editFormData.maintenance_category || ''}
                  onChange={(e) => setEditFormData(prev => ({ ...prev, maintenance_category: e.target.value }))}
                  placeholder="e.g., Electrical, Mechanical, Plumbing..."
                  style={{
                    borderColor: editFormData.maintenance_category !== ticket.maintenance_category ? '#0d6efd' : '#d1d5db',
                    borderWidth: editFormData.maintenance_category !== ticket.maintenance_category ? '2px' : '1px'
                  }}
                />
                {editFormData.maintenance_category !== ticket.maintenance_category && (
                  <small style={{ color: '#0d6efd' }}>
                    <i className="fas fa-pen"></i> Changed from: "{ticket.maintenance_category || 'N/A'}"
                  </small>
                )}
              </div>

              {/* Date Fields - Pre-filled with proper format */}
              <div className="td-form-row">
                <div className="td-form-group">
                  <label>Assigned Completion Date</label>
                  <input
                    type="date"
                    className="td-form-input"
                    value={editFormData.assigned_completion_date || ''}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, assigned_completion_date: e.target.value }))}
                    style={{
                      borderColor: editFormData.assigned_completion_date !== ticket.assigned_completion_date ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.assigned_completion_date !== ticket.assigned_completion_date ? '2px' : '1px'
                    }}
                  />
                  {ticket.assigned_completion_date && (
                    <small style={{ color: editFormData.assigned_completion_date !== ticket.assigned_completion_date ? '#0d6efd' : '#6c757d' }}>
                      {editFormData.assigned_completion_date !== ticket.assigned_completion_date ? (
                        <>
                          <i className="fas fa-pen"></i> Changed from: {formatDate(ticket.assigned_completion_date)}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check"></i> Current: {formatDate(ticket.assigned_completion_date)}
                        </>
                      )}
                    </small>
                  )}
                </div>
                <div className="td-form-group">
                  <label>Tentative Completion Date</label>
                  <input
                    type="date"
                    className="td-form-input"
                    value={editFormData.tentative_completion_date || ''}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, tentative_completion_date: e.target.value }))}
                    style={{
                      borderColor: editFormData.tentative_completion_date !== ticket.tentative_completion_date ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.tentative_completion_date !== ticket.tentative_completion_date ? '2px' : '1px'
                    }}
                  />
                  {ticket.tentative_completion_date && (
                    <small style={{ color: editFormData.tentative_completion_date !== ticket.tentative_completion_date ? '#0d6efd' : '#6c757d' }}>
                      {editFormData.tentative_completion_date !== ticket.tentative_completion_date ? (
                        <>
                          <i className="fas fa-pen"></i> Changed from: {formatDate(ticket.tentative_completion_date)}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check"></i> Current: {formatDate(ticket.tentative_completion_date)}
                        </>
                      )}
                    </small>
                  )}
                </div>
              </div>

              <div className="td-form-row">
                <div className="td-form-group">
                  <label>Schedule Start Date</label>
                  <input
                    type="date"
                    className="td-form-input"
                    value={editFormData.schedule_start_date || ''}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, schedule_start_date: e.target.value }))}
                    style={{
                      borderColor: editFormData.schedule_start_date !== ticket.schedule_start_date ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.schedule_start_date !== ticket.schedule_start_date ? '2px' : '1px'
                    }}
                  />
                  {ticket.schedule_start_date && (
                    <small style={{ color: editFormData.schedule_start_date !== ticket.schedule_start_date ? '#0d6efd' : '#6c757d' }}>
                      {editFormData.schedule_start_date !== ticket.schedule_start_date ? (
                        <>
                          <i className="fas fa-pen"></i> Changed from: {formatDate(ticket.schedule_start_date)}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check"></i> Current: {formatDate(ticket.schedule_start_date)}
                        </>
                      )}
                    </small>
                  )}
                </div>
                <div className="td-form-group">
                  <label>Schedule End Date</label>
                  <input
                    type="date"
                    className="td-form-input"
                    value={editFormData.schedule_end_date || ''}
                    onChange={(e) => setEditFormData(prev => ({ ...prev, schedule_end_date: e.target.value }))}
                    style={{
                      borderColor: editFormData.schedule_end_date !== ticket.schedule_end_date ? '#0d6efd' : '#d1d5db',
                      borderWidth: editFormData.schedule_end_date !== ticket.schedule_end_date ? '2px' : '1px'
                    }}
                  />
                  {ticket.schedule_end_date && (
                    <small style={{ color: editFormData.schedule_end_date !== ticket.schedule_end_date ? '#0d6efd' : '#6c757d' }}>
                      {editFormData.schedule_end_date !== ticket.schedule_end_date ? (
                        <>
                          <i className="fas fa-pen"></i> Changed from: {formatDate(ticket.schedule_end_date)}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check"></i> Current: {formatDate(ticket.schedule_end_date)}
                        </>
                      )}
                    </small>
                  )}
                </div>
              </div>

              {/* Reason for Change */}
              <div className="td-form-group">
                <label>{isManager ? 'Reason for Change (Optional)' : 'Reason for Change (Required)'}</label>
                <textarea
                  className="td-form-textarea"
                  rows="2"
                  value={editReason}
                  onChange={(e) => setEditReason(e.target.value)}
                  placeholder={isManager ? "Optional: Add a note about these changes..." : "Please explain why you need to make these changes..."}
                  style={{
                    borderColor: !isManager && !editReason.trim() ? '#dc3545' : '#d1d5db',
                    borderWidth: !isManager && !editReason.trim() ? '2px' : '1px'
                  }}
                />
                {!isManager && !editReason.trim() && (
                  <small style={{ color: '#dc3545' }}>
                    <i className="fas fa-exclamation-circle"></i> Please provide a reason for the change request
                  </small>
                )}
              </div>

              {/* Changed Fields Summary */}
              {(() => {
                const changedFields = [];
                const fieldLabels = {
                  issue_description: 'Issue Description',
                  maintenance_category: 'Category',
                  type: 'Type',
                  priority: 'Priority',
                  assigned_completion_date: 'Assigned Completion Date',
                  tentative_completion_date: 'Tentative Completion Date',
                  schedule_start_date: 'Schedule Start Date',
                  schedule_end_date: 'Schedule End Date'
                };
                const fields = Object.keys(fieldLabels);
                fields.forEach(field => {
                  if (editFormData[field] !== ticket[field]) {
                    changedFields.push(fieldLabels[field]);
                  }
                });
                if (changedFields.length > 0) {
                  return (
                    <div className="td-changed-fields-summary" style={{
                      background: '#e8f4fd',
                      padding: '12px 16px',
                      borderRadius: '6px',
                      marginTop: '12px',
                      borderLeft: '4px solid #0d6efd'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fas fa-list" style={{ color: '#0d6efd' }}></i>
                        <strong style={{ color: '#0d6efd' }}>Fields to be updated ({changedFields.length}):</strong>
                      </div>
                      <div style={{ marginTop: '4px', color: '#0d6efd', fontSize: '14px' }}>
                        {changedFields.join(', ')}
                      </div>
                    </div>
                  );
                }
                return (
                  <div className="td-changed-fields-summary" style={{
                    background: '#f8f9fa',
                    padding: '12px 16px',
                    borderRadius: '6px',
                    marginTop: '12px',
                    borderLeft: '4px solid #6c757d',
                    color: '#6c757d'
                  }}>
                    <i className="fas fa-info-circle"></i> No changes detected. Modify at least one field to submit.
                  </div>
                );
              })()}

              {!isManager && (
                <div className="td-approval-notice" style={{
                  background: '#dbeafe',
                  borderLeft: '4px solid #3b82f6',
                  marginTop: '12px',
                  padding: '12px 16px',
                  borderRadius: '6px'
                }}>
                  <i className="fas fa-info-circle" style={{ color: '#3b82f6' }}></i>
                  <span style={{ color: '#1e40af', marginLeft: '8px' }}>
                    All changes will be reviewed by a manager before being applied. You will be notified when approved or rejected.
                  </span>
                </div>
              )}
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-primary"
                onClick={handleEditSubmit}
                disabled={isSubmittingEdit || (!isManager && !editReason.trim())}
              >
                {isSubmittingEdit ? (
                  <>
                    <span className="td-spinner"></span> Submitting...
                  </>
                ) : (
                  isManager ? 'Apply Changes' : 'Submit for Approval'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== REOPEN MODAL ===== */}
      {showReopenModal && (
        <div className="td-modal-overlay" onClick={() => setShowReopenModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header td-modal-warning">
              <h3><i className="fas fa-undo"></i> Reopen Ticket</h3>
              <button className="td-modal-close" onClick={() => setShowReopenModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-warning" style={{ background: '#fff3cd', padding: '12px', borderRadius: '6px', marginBottom: '16px', borderLeft: '4px solid #ffc107' }}>
                <i className="fas fa-exclamation-triangle" style={{ color: '#856404' }}></i>
                <p style={{ margin: '8px 0 0 0', color: '#856404' }}>
                  <strong>Warning:</strong> This will reopen the ticket and set it back to "In Progress".
                  You will need to complete the work properly and resubmit for manager approval.
                </p>
              </div>
              <div className="td-form-group">
                <label>Reason for Reopening <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="3"
                  value={reopenReason}
                  onChange={(e) => setReopenReason(e.target.value)}
                  placeholder="Please explain why you need to reopen this ticket..."
                  style={{
                    borderColor: !reopenReason.trim() ? '#dc3545' : '#d1d5db',
                    borderWidth: !reopenReason.trim() ? '2px' : '1px'
                  }}
                />
                {!reopenReason.trim() && (
                  <small style={{ color: '#dc3545' }}>
                    <i className="fas fa-exclamation-circle"></i> Please provide a reason for reopening
                  </small>
                )}
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowReopenModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-warning"
                onClick={handleReopenTicket}
                disabled={isReopening || !reopenReason.trim()}
                style={{ background: '#ffc107', color: '#000' }}
              >
                {isReopening ? 'Reopening...' : 'Yes, Reopen Ticket'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== REJECT COMPLETION MODAL ===== */}
      {showRejectModal && (
        <div className="td-modal-overlay" onClick={() => setShowRejectModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header td-modal-danger">
              <h3>
                <i className="fas fa-times-circle" style={{ color: '#dc3545' }}></i>
                Reject Completion
              </h3>
              <button className="td-modal-close" onClick={() => setShowRejectModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-warning" style={{
                background: '#fee2e2',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '16px',
                borderLeft: '4px solid #dc3545'
              }}>
                <i className="fas fa-exclamation-triangle" style={{ color: '#991b1b' }}></i>
                <p style={{ margin: '8px 0 0 0', color: '#991b1b' }}>
                  <strong>Warning:</strong> You are about to reject this completion.
                  The ticket will remain in its current state, and the maintenance team will have the option to reopen it.
                </p>
              </div>

              <div className="td-form-group">
                <label>Reason for Rejection <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="4"
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Please provide a detailed reason for rejecting this completion. This will help the maintenance team understand what needs to be fixed..."
                  style={{
                    borderColor: !rejectReason.trim() ? '#dc3545' : '#d1d5db',
                    borderWidth: !rejectReason.trim() ? '2px' : '1px'
                  }}
                />
                {!rejectReason.trim() && (
                  <small style={{ color: '#dc3545' }}>
                    <i className="fas fa-exclamation-circle"></i> Please provide a reason for rejection
                  </small>
                )}
              </div>

              <div className="td-info-box" style={{
                background: '#e8f4fd',
                padding: '12px',
                borderRadius: '6px',
                marginTop: '12px',
                borderLeft: '4px solid #0d6efd'
              }}>
                <i className="fas fa-info-circle" style={{ color: '#0d6efd' }}></i>
                <span style={{ color: '#0d6efd', marginLeft: '8px' }}>
                  The ticket will stay in its current state. The maintenance team can reopen it when they're ready to fix and resubmit.
                </span>
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowRejectModal(false)}>
                Cancel
              </button>
              <button
                className="td-btn td-btn-danger"
                onClick={handleRejectConfirm}
                disabled={isRejecting || !rejectReason.trim()}
              >
                {isRejecting ? (
                  <>
                    <span className="td-spinner"></span> Processing...
                  </>
                ) : (
                  'Yes, Reject Completion'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== COMPLETION MODAL ===== */}
      {showCompleteModal && (
        <div className="td-modal-overlay" onClick={() => setShowCompleteModal(false)}>
          <div className="td-modal" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3>
                <i className="fas fa-check-circle" style={{ color: ticket?.is_recurring && ticket?.recurrence_parent_id ? '#ffc107' : '#22c55e' }}></i>
                {ticket?.is_recurring && ticket?.recurrence_parent_id ? 'Close Current Instance' : 'Complete Ticket'}
              </h3>
              <button className="td-modal-close" onClick={() => setShowCompleteModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-info">
                <p><strong>Ticket:</strong> {ticket.ticket_number}</p>
                <p><strong>Issue:</strong> {ticket.issue_description}</p>
                {ticket.is_recurring && ticket.recurrence_instance_date && (
                  <p><strong>Instance Date:</strong> {formatDate(ticket.recurrence_instance_date)}</p>
                )}
                {completionData.warning_message && (
                  <p className="td-modal-hint" style={{ color: '#0d6efd', background: '#cfe2ff', padding: '8px', borderRadius: '6px' }}>
                    <i className="fas fa-info-circle"></i> {completionData.warning_message}
                  </p>
                )}
                {completionData.is_delayed && (
                  <p className="td-modal-hint" style={{ color: '#dc2626' }}>
                    <i className="fas fa-exclamation-triangle"></i>
                    This ticket is overdue. Please provide a reason for the delay.
                  </p>
                )}
              </div>

              <div className="td-form-group">
                <label>Completion Notes <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="4"
                  value={completionData.completion_notes}
                  onChange={(e) => setCompletionData(prev => ({ ...prev, completion_notes: e.target.value }))}
                  placeholder={ticket?.is_recurring && ticket?.recurrence_parent_id ?
                    "Describe the work completed for this instance..." :
                    "Describe the work completed..."}
                />
              </div>

              {completionData.is_delayed && (
                <div className="td-form-group">
                  <label>Delay Reason <span className="td-required">*</span></label>
                  <textarea
                    className="td-form-textarea"
                    rows="3"
                    value={completionData.delay_reason}
                    onChange={(e) => setCompletionData(prev => ({ ...prev, delay_reason: e.target.value }))}
                    placeholder="Explain why this ticket was delayed..."
                  />
                </div>
              )}

              <div className="td-approval-notice" style={{ background: '#dbeafe', borderLeftColor: '#3b82f6' }}>
                <i className="fas fa-info-circle" style={{ color: '#3b82f6' }}></i>
                <span style={{ color: '#1e40af' }}>
                  {ticket?.is_recurring && ticket?.recurrence_parent_id ?
                    'This will close the current instance. A new instance will be created automatically for the next period. Manager approval is required.' :
                    'This completion will be sent to the manager for approval before the ticket is closed.'
                  }
                </span>
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowCompleteModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-success"
                onClick={handleCompleteSubmit}
                disabled={isSubmittingComplete || !completionData.completion_notes.trim() || (completionData.is_delayed && !completionData.delay_reason.trim())}
              >
                {isSubmittingComplete ? (
                  <>
                    <span className="td-spinner"></span> Submitting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check"></i>
                    {ticket?.is_recurring && ticket?.recurrence_parent_id ? 'Close Instance' : 'Submit for Approval'}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== PURCHASE REQUEST MODAL ===== */}
      {showPurchaseModal && renderPurchaseModal()}

      {/* ===== PURCHASE REQUEST DETAIL MODAL ===== */}
      {showPurchaseDetail && selectedPurchaseRequest && (
        <div className="td-modal-overlay" onClick={() => setShowPurchaseDetail(false)}>
          <div className="td-modal td-modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3>
                <i className="fas fa-file-invoice"></i>
                Purchase Request Details
              </h3>
              <button className="td-modal-close" onClick={() => setShowPurchaseDetail(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-purchase-detail-grid">
                <div className="td-detail-item">
                  <label>ID</label>
                  <span className="td-detail-value">{selectedPurchaseRequest.ID || selectedPurchaseRequest.id || 'N/A'}</span>
                </div>
                <div className="td-detail-item">
                  <label>Ticket Number</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Ticket_No ||
                      selectedPurchaseRequest.ticket_no ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Part Number</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Part_No ||
                      selectedPurchaseRequest.part_no ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Description</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Item_Desc ||
                      selectedPurchaseRequest.item_desc ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Brand</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Brand ||
                      selectedPurchaseRequest.brand ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Quantity</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Qty ||
                      selectedPurchaseRequest.qty ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Unit</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Unit ||
                      selectedPurchaseRequest.unit ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Vendor</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Vendor ||
                      selectedPurchaseRequest.vendor ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>PO Number</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.PO_No ||
                      selectedPurchaseRequest.po_no ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Requested By</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Name ||
                      selectedPurchaseRequest.name ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Request Date</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Requested_Date ?
                      formatDate(selectedPurchaseRequest.Requested_Date) :
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Required Before</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Required_Before ?
                      formatDate(selectedPurchaseRequest.Required_Before) :
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Completion Date</label>
                  <span className="td-detail-value" style={{
                    color: selectedPurchaseRequest.Completion_Time &&
                      ticket &&
                      new Date(selectedPurchaseRequest.Completion_Time.split('T')[0]) > new Date(ticket.tentative_completion_date.split('T')[0])
                      ? '#dc3545'
                      : '#28a745'
                  }}>
                    {selectedPurchaseRequest.Completion_Time ?
                      formatDate(selectedPurchaseRequest.Completion_Time) :
                      'N/A'}
                    {selectedPurchaseRequest.Completion_Time &&
                      ticket &&
                      new Date(selectedPurchaseRequest.Completion_Time.split('T')[0]) > new Date(ticket.tentative_completion_date.split('T')[0]) && (
                        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#dc3545' }}>
                          ⚠️ Late
                        </span>
                      )}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Status</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Status ||
                      selectedPurchaseRequest.status ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item">
                  <label>Approval</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Approval ||
                      selectedPurchaseRequest.approval ||
                      'N/A'}
                  </span>
                </div>
                <div className="td-detail-item" style={{ gridColumn: '1 / -1' }}>
                  <label>Comments</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Comments ||
                      selectedPurchaseRequest.comments ||
                      'No comments'}
                  </span>
                </div>
                <div className="td-detail-item" style={{ gridColumn: '1 / -1' }}>
                  <label>Notes</label>
                  <span className="td-detail-value">
                    {selectedPurchaseRequest.Notes ||
                      selectedPurchaseRequest.notes ||
                      'No notes'}
                  </span>
                </div>
                {selectedPurchaseRequest.File_Link && (
                  <div className="td-detail-item" style={{ gridColumn: '1 / -1' }}>
                    <label>Attachments</label>
                    <div className="td-attachments">
                      {(() => {
                        try {
                          const files = typeof selectedPurchaseRequest.File_Link === 'string'
                            ? JSON.parse(selectedPurchaseRequest.File_Link)
                            : selectedPurchaseRequest.File_Link;
                          if (Array.isArray(files) && files.length > 0) {
                            return files.map((link, idx) => (
                              <a
                                key={idx}
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="td-attachment-link"
                              >
                                <i className="fas fa-paperclip"></i> Attachment {idx + 1}
                              </a>
                            ));
                          }
                          return <span>No attachments</span>;
                        } catch (e) {
                          return <span>No attachments</span>;
                        }
                      })()}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="td-modal-footer">
              <button
                className="td-btn td-btn-secondary"
                onClick={() => setShowPurchaseDetail(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== ASSIGNEE MODAL ===== */}
      {showAssigneeModal && (
        <div className="td-modal-overlay" onClick={() => setShowAssigneeModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3><i className="fas fa-user-plus"></i> Assign Ticket</h3>
              <button className="td-modal-close" onClick={() => setShowAssigneeModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-form-group">
                <label>Assignee Name <span className="td-required">*</span></label>
                <select
                  className="td-form-select"
                  value={assigneeName}
                  onChange={(e) => setAssigneeName(e.target.value)}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                >
                  <option value="">Select an employee...</option>
                  {employeeList.map((employee, index) => (
                    <option key={index} value={employee}>{employee}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowAssigneeModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-primary"
                onClick={handleAssigneeUpdate}
                disabled={!assigneeName.trim()}
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== CREATE INSTANCE MODAL ===== */}
      {showCreateInstanceModal && (
        <div className="td-modal-overlay" onClick={() => setShowCreateInstanceModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3>
                <i className="fas fa-plus-circle" style={{ color: '#28a745' }}></i>
                Create New Instance
              </h3>
              <button className="td-modal-close" onClick={() => setShowCreateInstanceModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-info" style={{ marginBottom: '16px' }}>
                <p><strong>Parent Ticket:</strong> {ticket?.ticket_number}</p>
                <p><strong>Issue:</strong> {ticket?.issue_description}</p>
                <p className="td-modal-hint" style={{ color: '#0d6efd', background: '#cfe2ff', padding: '8px', borderRadius: '6px' }}>
                  <i className="fas fa-info-circle"></i>
                  Create a new instance for this recurring ticket.
                  {ticket?.approval_status === 'Approved'
                    ? ' The instance will be automatically approved (inherited from parent).'
                    : ' The instance will be pending until parent is approved.'}
                </p>
              </div>

              <div className="td-form-group">
                <label>Instance Date <span className="td-required">*</span></label>
                <input
                  type="date"
                  className="td-form-input"
                  value={instanceDate}
                  onChange={(e) => setInstanceDate(e.target.value)}
                  min={new Date().toISOString().slice(0, 10)}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                />
                <small style={{ color: '#6c757d', marginTop: '4px', display: 'block' }}>
                  Select the date for this instance (must be today or future)
                </small>
              </div>
            </div>
            <div className="td-modal-footer">
              <button
                className="td-btn td-btn-secondary"
                onClick={() => setShowCreateInstanceModal(false)}
              >
                Cancel
              </button>
              <button
                className="td-btn td-btn-success"
                onClick={handleCreateInstance}
                disabled={isCreatingInstance || !instanceDate}
              >
                {isCreatingInstance ? (
                  <>
                    <span className="td-spinner"></span> Creating...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check"></i> Create Instance
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== CLOSE SERIES MODAL ===== */}
      {showCloseSeriesModal && (
        <div className="td-modal-overlay" onClick={() => setShowCloseSeriesModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header td-modal-danger">
              <h3><i className="fas fa-exclamation-triangle"></i> Close Entire Series</h3>
              <button className="td-modal-close" onClick={() => setShowCloseSeriesModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-warning" style={{ background: '#fff3cd', padding: '12px', borderRadius: '6px', marginBottom: '16px' }}>
                <i className="fas fa-exclamation-triangle" style={{ color: '#856404' }}></i>
                <p style={{ margin: '8px 0 0 0', color: '#856404' }}>
                  <strong>Warning:</strong> This will close ALL instances of this recurring ticket, including past, current, and future ones.
                  This action cannot be undone.
                </p>
              </div>
              <div className="td-form-group">
                <label>Reason for closing series <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="3"
                  value={closeSeriesReason}
                  onChange={(e) => setCloseSeriesReason(e.target.value)}
                  placeholder="Please provide a reason for closing the entire series..."
                />
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowCloseSeriesModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-danger"
                onClick={handleCloseSeries}
                disabled={isDeleting || !closeSeriesReason.trim()}
              >
                {isDeleting ? 'Closing...' : 'Yes, Close Series'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== CANCEL MODAL ===== */}
      {showCancelModal && (
        <div className="td-modal-overlay" onClick={() => setShowCancelModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header td-modal-danger">
              <h3><i className="fas fa-exclamation-triangle"></i> Cancel Ticket</h3>
              <button className="td-modal-close" onClick={() => setShowCancelModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <p>Are you sure you want to cancel this ticket?</p>
              <div className="td-form-group">
                <label>Cancellation Reason <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="3"
                  value={cancellationReason}
                  onChange={(e) => setCancellationReason(e.target.value)}
                  placeholder="Please provide a reason for cancellation..."
                />
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowCancelModal(false)}>No, Keep Ticket</button>
              <button
                className="td-btn td-btn-danger"
                onClick={handleCancelTicket}
                disabled={isDeleting || !cancellationReason.trim()}
              >
                {isDeleting ? 'Cancelling...' : 'Yes, Cancel Ticket'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== DELETE TICKET MODAL (Manager only - permanent DB delete) ===== */}
      {showDeleteModal && (
        <div className="td-modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header td-modal-danger">
              <h3><i className="fas fa-trash-alt"></i> Delete Ticket Permanently</h3>
              <button className="td-modal-close" onClick={() => setShowDeleteModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <div className="td-modal-warning" style={{
                background: '#fee2e2',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '16px',
                borderLeft: '4px solid #7f1d1d'
              }}>
                <i className="fas fa-exclamation-triangle" style={{ color: '#7f1d1d' }}></i>
                <p style={{ margin: '8px 0 0 0', color: '#7f1d1d' }}>
                  <strong>Warning:</strong> This will permanently delete ticket <strong>{ticket?.ticket_number}</strong> from
                  the database. This action <strong>cannot be undone</strong> and is different from cancelling —
                  the record will no longer exist anywhere in the system.
                </p>
              </div>
              <div className="td-form-group">
                <label>Reason for Deletion <span className="td-required">*</span></label>
                <textarea
                  className="td-form-textarea"
                  rows="3"
                  value={deleteReason}
                  onChange={(e) => setDeleteReason(e.target.value)}
                  placeholder="Please provide a reason for permanently deleting this ticket..."
                  style={{
                    borderColor: !deleteReason.trim() ? '#dc3545' : '#d1d5db',
                    borderWidth: !deleteReason.trim() ? '2px' : '1px'
                  }}
                />
                {!deleteReason.trim() && (
                  <small style={{ color: '#dc3545' }}>
                    <i className="fas fa-exclamation-circle"></i> Please provide a reason for deletion
                  </small>
                )}
              </div>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button
                className="td-btn td-btn-danger"
                onClick={handleDeleteTicket}
                disabled={isDeletingRecord || !deleteReason.trim()}
                style={{ background: '#7f1d1d' }}
              >
                {isDeletingRecord ? 'Deleting...' : 'Yes, Delete Permanently'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== SUCCESS MODAL ===== */}
      {showSuccessModal && (
        <div className="td-modal-overlay" onClick={() => setShowSuccessModal(false)}>
          <div className="td-modal td-modal-sm td-modal-success" onClick={(e) => e.stopPropagation()}>
            <div className="td-modal-header">
              <h3><i className="fas fa-check-circle"></i> Success</h3>
              <button className="td-modal-close" onClick={() => setShowSuccessModal(false)}>×</button>
            </div>
            <div className="td-modal-body">
              <p>{successMessage}</p>
            </div>
            <div className="td-modal-footer">
              <button className="td-btn td-btn-primary" onClick={() => setShowSuccessModal(false)}>OK</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketDetail;